import { useState, useRef } from 'react';
import { API_URL, baseUrl, uploadFile } from '../../../api';
import axios from 'axios';
import { toast } from 'react-toastify';
import StyledButton from '../StyledButton';

const FileUploader = ({ allowedFormats, uploadType, reqData={}, onResponse =() => {}, title = 'Import' }) => {
	const [isUploading, setUploading] = useState(false);
	const fileInputRef = useRef(null);

	const onUploadFile = async (file) => {
		try {
			const formData = new FormData();
			formData.append('file', file);

			const response = await uploadFile(uploadType, formData)

			if (response.status === 200) {
				onResponse(response.data.key);
				toast.success('Successfully uploaded!');
			} else {
				toast.error('Failed to upload. Try again');
			}
		} catch (error) {
			console.log(error);
			toast.error('Failed to upload. Try again');
		} finally {
			setUploading(false);
			fileInputRef.current.value = null;
		}
	};

	const validateAndUploadFiles = (files) => {
		if (!files.length) return;

		const filteredFiles = files.filter(({ name }) => {
			const ext = name.split('.').pop().toLowerCase();
			return allowedFormats.includes(ext);
		});

		if (filteredFiles.length === 0) {
			toast.error('Invalid file format.');
			return;
		}

		setUploading(true);
		onUploadFile(filteredFiles[0]); // Upload only the first valid file
	};

	const handleFileChange = (event) => {
		const files = Array.from(event.target.files);
		validateAndUploadFiles(files);
	};

	const handleClickToUpload = () => {
		fileInputRef.current.click();
	};

	return (
		<>
			<input
				type="file"
				ref={fileInputRef}
				onChange={handleFileChange}
				style={{ display: 'none' }}
				accept={allowedFormats.map(ext => `.${ext}`).join(',')}
			/>
			<StyledButton
				color="primary"
				className="w-md"
				onClick={handleClickToUpload}
				isLoading={isUploading}
			>
				<div>
					<i className="ion ion-md-cloud-download mx-2"></i>
					{title}
				</div>
			</StyledButton>
		</>
	);
};

export default FileUploader;